import { Component, OnInit } from '@angular/core';
import { MonitoringService } from '../../service/monitoring.service';
import { ErrorHandlerService } from '../../../services/shared/error-handler.service';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import swal from "sweetalert2";

@Component({
  selector: 'app-errors-dashboard',
  templateUrl: './errors-dashboard.component.html',
  styleUrls: ['./errors-dashboard.component.css']
})
export class ErrorsDashboardComponent implements OnInit {
  errors: any = {};
  dashboardCards: any = {};
  filterForm: FormGroup;
  expandedMessageIds = new Set<string | number>();
  statusOptions = [
    {
      value: 'open',
      label: 'Open'
    },
    {
      value: 'resolved',
      label: 'Resolved'
    },
  ];

  constructor(
    private router: Router,
    private fb: FormBuilder,
    private monitoringService: MonitoringService,
    private errorHandlerService: ErrorHandlerService
  ) {
    this.initalizeFilterForm();
  }
  
  ngOnInit() {
    this.getErrors();
    this.getErrorsDashboard();
  }

  initalizeFilterForm() {
    this.filterForm = this.fb.group({
      status: [null],
      type: [null],
      hash: [null],
      date_from: [null],
      date_to: [null],
    });
  }

  resetFilters() {
    this.filterForm.reset();
    this.getErrors();
  }

  shouldShowMessageToggle(message: any): boolean {
    return typeof message === 'string' && message.trim().length > 160;
  }

  isMessageExpanded(errorId: string | number): boolean {
    return this.expandedMessageIds.has(errorId);
  }

  toggleMessage(errorId: string | number) {
    if (this.expandedMessageIds.has(errorId)) {
      this.expandedMessageIds.delete(errorId);
      return;
    }

    this.expandedMessageIds.add(errorId);
  }

  getErrors() {
    let params = this.filterForm.value;
    this.monitoringService.getErrors(params).subscribe({
      next: (data) => {
        this.errors = data;
        this.expandedMessageIds.clear();
      },
      error: (error) => {
        this.errorHandlerService.handleErorr(error);
      },
    });
  }

  getErrorsDashboard() {
    this.monitoringService.getErrorsDashboard().subscribe({
      next: (res) => {
        this.dashboardCards = res.data;
      },
      error: (error) => {
        this.errorHandlerService.handleErorr(error);
      },
    });
  }

  viewDetails(error: any) {
    this.router.navigate([`/pages/monitoring/details/`, error.id]);
  }

  goToPerv() {
    this.monitoringService.infinte(this.errors.links.prev).subscribe({
      next: (data) => {
        this.errors = data;
        this.expandedMessageIds.clear();
      },
      error: (error) => {
        this.errorHandlerService.handleErorr(error);
      },
    })
  }

  goToNext() {
    this.monitoringService.infinte(this.errors.links.next).subscribe({
      next: (data) => {
        this.errors = data;
        this.expandedMessageIds.clear();
      },
      error: (error) => {
        this.errorHandlerService.handleErorr(error);
      },
    })
  }

  resolveError(id: string | number) {
    swal({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, resolve it!'
    }).then((result) => {
      if (result.value) {
        this.monitoringService.resolveError(id).subscribe({
          next: (data) => {
            this.getErrors();
            this.getErrorsDashboard();
          },
          error: (error) => {
            this.errorHandlerService.handleErorr(error);
          },
        });
      } else {
        swal(
          'Cancelled',
          'Your error has not been resolved',
          'info'
        )
      }
    })
    
  }

  reopenError(id: string | number) {
    swal({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, reopen it!'
    }).then((result) => {
      if (result.value) {
        this.monitoringService.reopenError(id).subscribe({
          next: (data) => {
            this.getErrors();
            this.getErrorsDashboard();
          },
          error: (error) => {
            this.errorHandlerService.handleErorr(error);
          },
        });
      } else {
        swal(
          'Cancelled',
          'Your error has not been reopened',
          'info'
        )
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/monitoring/components/errors-dashboard/errors-dashboard.component.ts